import { render, staticRenderFns } from "./BalanceLevelTab.vue?vue&type=template&id=f90ddd3e&scoped=true"
import script from "./BalanceLevelTab.vue?vue&type=script&lang=js"
export * from "./BalanceLevelTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceLevelTab.vue?vue&type=style&index=0&id=f90ddd3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90ddd3e",
  null
  
)

export default component.exports